import { useEffect, useState, useContext } from "react";
import {
  Box,
  Typography,
  Card,
  Tabs,
  Tab,
  TableContainer,
  Paper,
  CircularProgress,
} from "@mui/material";
import { Search, Upload, Translate } from "@mui/icons-material";
import ResultsTable from "../bulk-search/Table";
import "./styles.css";
import { useLocation } from "react-router-dom";
import UserContext from "../../context/user";
import api from "../../service/api";

const UploadHistory = () => {
  const UserInfo = useContext(UserContext);
  const location = useLocation();
  const defaultTab = location.state?.defaultTab || "BULKSEARCH";
  const [activeFilter, setActiveFilter] = useState(defaultTab);
  const [results, setResults] = useState([]);
  const [currentCursor, setCurrentCursor] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const headers = [
    "File Name",
    "Upload ID",
    "Uploaded By",
    "Upload Date",
    "Status",
    "Actions",
  ];

  const filters = [
    { label: "All", value: "All" },
    { label: "Success", value: "completed" },
    { label: "Failed", value: "Failed" },
    { label: "Pending", value: "pending" },
  ];
  const bulkUploadFilters = [
    { label: "All", value: "All" },
    { label: "Review Pending", value: "REVIEW_PENDING" },
    { label: "Review Submitted", value: "REVIEW_SUBMITTED" },
  ];
  const tabFilters = [
    { label: "Bulk Search", value: "BULKSEARCH" },
    { label: "Bulk Upload", value: "BULKUPLOAD" },
    { label: "Transliteration", value: "TRANSLITERATION" },
  ];

  const handleTabChange = (event, newValue) => {
    setActiveFilter(newValue);
  };
  const getHistory = async (cursor = "", previousResults = []) => {
    setIsLoading(true);
    let data = [];
    try {
      const response = await api.fetchUploadHistory(activeFilter, cursor);
      data = [...previousResults, ...response.data.items];
      setResults(data);
      setCurrentCursor(response.data.cursor);
    } catch (error) {
      console.error("Error fetching upload history:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setResults([]);
    setCurrentCursor("");
    getHistory("", []);
  }, [activeFilter]);

  return (
    <div className="container body-height extra-margin-top-less mb-4">
      <Card sx={{ maxWidth: 1250 }} className="mx-auto">
        <Box sx={{ p: 3, mx: "auto" }}>
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              sx={{ color: "#101828", mb: 1, fontWeight: 600 }}
            >
              File Upload History
            </Typography>
            <Typography variant="body1" sx={{ color: "#4A5565" }}>
              Track and manage all your file upload operations
            </Typography>
          </Box>
          <Paper sx={{ mb: 3, display: "inline-block" }}>
            <Tabs
              value={activeFilter}
              onChange={handleTabChange}
              className="bulk-ops-tabs"
              sx={{
                "& .MuiTab-root": {
                  textTransform: "none",
                  minHeight: 48,
                  "&.Mui-selected": {
                    backgroundColor: "#E7000B",
                    color: "white",
                    borderRadius: 1,
                  },
                },
              }}
            >
              {tabFilters.map((tab) => (
                <Tab
                  key={tab.value}
                  value={tab.value}
                  icon={
                    tab.value === "BULKSEARCH" ? (
                      <Search />
                    ) : tab.value === "BULKUPLOAD" ? (
                      <Upload />
                    ) : (
                      <Translate />
                    )
                  }
                  iconPosition="start"
                  label={tab.label}
                  disabled={
                    (tab.value === "BULKSEARCH" && !UserInfo?.canBulkSearch) ||
                    (tab.value === "BULKUPLOAD" && !UserInfo?.canBulkUpload) ||
                    (tab.value === "TRANSLITERATION" &&
                      !UserInfo?.canTransliterate)
                  }
                />
              ))}
            </Tabs>
          </Paper>
          <TableContainer component={Paper} sx={{ boxShadow: 1 }}>
            {isLoading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "400px",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                <CircularProgress sx={{ color: "#E7000B" }} />
                <Typography variant="body1" sx={{ color: "#4A5565" }}>
                  Loading history...
                </Typography>
              </Box>
            ) : (
              <ResultsTable
                key={activeFilter}
                tableData={results}
                headers={headers}
                filters={
                  activeFilter === "BULKUPLOAD" ? bulkUploadFilters : filters
                }
                sortableColumns={["uploadedBy", "uploadDate"]}
                tableType="upload-history"
                fetchMoreRecords={() => getHistory(currentCursor, results)}
                cursor={currentCursor}
              />
            )}
          </TableContainer>
        </Box>
      </Card>
    </div>
  );
};

export default UploadHistory;